import programDetailsLocale from './en.json'

const en = {
  programDetails: programDetailsLocale,
}

export default en
